import React, { useEffect, useState, useMemo } from 'react';
import { formatCurrency } from '../../../../../../../../../utils/functions';
import CreateBillModal from './CreateBillModal/CreateBillModal'; // Importa el modal
import { BillType } from '../../../../../types'; // Asegúrate de que la interfaz esté correctamente definida
import { FaPlus } from 'react-icons/fa';
import { Button } from 'react-bootstrap';

interface TableProps {
  data: BillType[]; 
  setData: (data: BillType[]) => void; 
  globalCategoriesList: any[];   // Añadido
  localCategoriesList: any[];    // Añadido
  fetchBills: () => void; // Función para obtener las facturas
}

const Table: React.FC<TableProps> = ({ data, setData, globalCategoriesList, localCategoriesList, fetchBills }) => {
  const [showModal, setShowModal] = useState(false); 
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 900);
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Llama una vez al inicio para establecer el estado inicial

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const sortedData = useMemo(() => {
    return [...data].sort((a, b) => {
      const da = new Date(a.bill_date).getTime();
      const db = new Date(b.bill_date).getTime();
      return db - da; 
    });
  }, [data]);

  const getCategoryName = (bill: BillType): string => {
    if (bill.global_bill_category_id) {
      return bill.global_bill_category_name || 'Categoría global no definida';
    } else if (bill.local_bill_category_id) {
      return bill.local_bill_category_name || 'Categoría local no definida';
    }
    return 'Sin categoría';
  };

  const formatDate = (dateString: string): string => {
    // Si viene en formato YYYY-MM-DD o YYYY-MM-DDTHH:mm:ss
    if (!dateString) return 'Fecha no válida';
    const onlyDate = dateString.split('T')[0];
    const [year, month, day] = onlyDate.split('-');
    if (!year || !month || !day) return 'Fecha no válida';
    return `${day}/${month}/${year}`;
  };

  const handleAddBill = (newBill: BillType) => {
    setData([newBill, ...data]);
    setShowModal(false);
    fetchBills();
  };

  return (
    <div className="custom-table-div">
      <div className="action-button-table-container">
        <Button variant='none' className="mp-button light" onClick={() => setShowModal(true)}>
          <FaPlus/> Crear Pago
        </Button>
      </div>
      <div className="scroll-container-table">
      <table className="custom-table">
        <thead>
          <tr>
            <th className='no_pagination'>Pago</th>
            <th className='no_pagination no-responsive'>Categoría</th>
            <th className='no_pagination no-responsive'>Estado</th>
            <th className='no_pagination'>Monto</th>
            <th className='no_pagination'>{isMobile?'Actualización':'Última actualización'}</th>
          </tr>
        </thead>
        <tbody>
          {sortedData.length === 0 ? (
              <tr><td colSpan={5} className="no-pendings">No hay registros</td></tr>
            ) : sortedData.map(bill => (
              <tr key={bill.bill_id}>
                <td>{bill.bill_name}</td>
                <td className='no-responsive'>{getCategoryName(bill)}</td>
                <td className='no-responsive'>{bill.is_deleted ? 'Eliminada' : 'Creada'}</td>
                <td>{formatCurrency(bill.amount)}</td>
                <td>{formatDate(bill.bill_date)}</td>
              </tr>
            ))}
        </tbody>
      </table>
      </div>

      {/* Pasamos globalCategoriesList y localCategoriesList al modal */}
      <CreateBillModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        handleAddBill={handleAddBill}
        globalCategoriesList={globalCategoriesList}
        localCategoriesList={localCategoriesList}
      />
    </div>
  );
};

export default Table;
